import * as Yup from 'yup'
import { Accordion, Form } from 'react-bootstrap'
import { CustomAccordionButton, CustomFormControl, CustomFormSelect } from '../../../../StyledComponents';
import { checkGrade, checkRequiredText, checkText } from '../ValidationRules';
import { Options } from '../SelectOptions';

export const Schema = (settings) => Yup.object().shape({
    study1: checkText(settings),
    study2: checkText(settings),
    study3: checkText(settings),
    studyGrade1: checkGrade,
    studyGrade2: checkGrade,
    studyGrade3: checkGrade,
    finalYearOfStudy1: Yup.date()
        .nullable()
        .typeError("Bitte geben Sie einen gültigen Wert an")
        .when("study1", {
            is: study1 => study1 !== undefined && study1 !== "",
            then: Yup.date()
                .required("Angabe ist erforderlich")
                .typeError("Bitte geben Sie einen gültigen Wert an")
        }),
    finalYearOfStudy2: Yup.date()
        .nullable()
        .typeError("Bitte geben Sie einen gültigen Wert an")
        .when("study2", {
            is: study2 => study2 !== undefined && study2 !== "",
            then: Yup.date()
                .required("Angabe ist erforderlich")
                .typeError("Bitte geben Sie einen gültigen Wert an")
        }),
    finalYearOfStudy3: Yup.date()
        .nullable()
        .typeError("Bitte geben Sie einen gültigen Wert an")
        .when("study3", {
            is: study3 => study3 !== undefined && study3 !== "",
            then: Yup.date()
                .required("Angabe ist erforderlich")
                .typeError("Bitte geben Sie einen gültigen Wert an")
        }),
});

export const StudySubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Accordion defaultActiveKey={['0']} alwaysOpen>
                <Accordion.Item eventKey="0">
                    <CustomAccordionButton colors={colors}>Studium 1</CustomAccordionButton>
                    <Accordion.Body>
                        <Form.Group className="mb-3" controlId="formStudy1">
                            <Form.Label>Studium</Form.Label>
                            <CustomFormControl
                                colors={colors}
                                placeholder="Abschluss"
                                type="text"
                                name="study1"
                                value={values.study1}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isValid={touched.study1 && !errors.study1}
                                isInvalid={errors.study1}
                                maxLength={settings.textInputLimit}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.study1}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formAcademicDegree1">
                            <Form.Label>Abschluss</Form.Label>
                            <CustomFormSelect
                                colors={colors}
                                name="academicDegree1"
                                value={values.academicDegree1}
                                isValid={touched.academicDegree1 && !errors.academicDegree1}
                                isInvalid={errors.academicDegree1}
                                onChange={handleChange}
                                onBlur={handleBlur}>
                                <option value="">Bitte auswählen...</option>
                                {Options.AcademicDegree.map((item, index) => <option key={index}>{item}</option>)}
                            </CustomFormSelect>
                            <Form.Control.Feedback type="invalid">
                                {errors.academicDegree1}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formStudy1Grade">
                            <Form.Label>Note</Form.Label>
                            <CustomFormControl
                                colors={colors}
                                placeholder="Note"
                                type="number"
                                name="studyGrade1"
                                value={values.studyGrade1 || ''}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isValid={touched.studyGrade1 && !errors.studyGrade1}
                                isInvalid={errors.studyGrade1}
                                maxLength={settings.textInputLimit}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.studyGrade1}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="finalYearOfStudy1">
                            <Form.Label>Abschlussdatum</Form.Label>
                            <CustomFormControl
                                colors={colors}
                                placeholder="Abschlussdatum"
                                type="date"
                                name="finalYearOfStudy1"
                                value={values.finalYearOfStudy1 || ''}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isValid={touched.finalYearOfStudy1 && !errors.finalYearOfStudy1}
                                isInvalid={errors.finalYearOfStudy1}
                                maxLength={settings.textInputLimit}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.finalYearOfStudy1}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                    <CustomAccordionButton colors={colors}>Studium 2</CustomAccordionButton>
                    <Accordion.Body>
                        <Form.Group className="mb-3" controlId="formStudy2">
                            <Form.Label>Studium</Form.Label>
                            <CustomFormControl
                                colors={colors}
                                placeholder="Abschluss"
                                type="text"
                                name="study2"
                                value={values.study2}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isValid={touched.study2 && !errors.study2}
                                isInvalid={errors.study2}
                                maxLength={settings.textInputLimit}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.study2}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formAcademicDegree2">
                            <Form.Label>Abschluss</Form.Label>
                            <CustomFormSelect
                                colors={colors}
                                name="academicDegree2"
                                value={values.academicDegree2}
                                isValid={touched.academicDegree2 && !errors.academicDegree2}
                                isInvalid={errors.academicDegree2}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            >
                                <option value="">Bitte auswählen...</option>
                                {Options.AcademicDegree.map((item, index) => <option key={index}>{item}</option>)}
                            </CustomFormSelect>
                            <Form.Control.Feedback type="invalid">
                                {errors.academicDegree2}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formStudy2Grade">
                            <Form.Label>Note</Form.Label>
                            <CustomFormControl
                                colors={colors}
                                placeholder="Note"
                                type="number"
                                name="studyGrade2"
                                value={values.studyGrade2 || ''}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isValid={touched.studyGrade2 && !errors.studyGrade2}
                                isInvalid={errors.studyGrade2}
                                maxLength={settings.textInputLimit}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.studyGrade2}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="finalYearOfStudy2">
                            <Form.Label>Abschlussdatum</Form.Label>
                            <CustomFormControl
                                colors={colors}
                                placeholder="Abschlussdatum"
                                type="date"
                                name="finalYearOfStudy2"
                                value={values.finalYearOfStudy2 || ''}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isValid={touched.finalYearOfStudy2 && !errors.finalYearOfStudy2}
                                isInvalid={errors.finalYearOfStudy2}
                                maxLength={settings.textInputLimit}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.finalYearOfStudy2}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                    <CustomAccordionButton colors={colors}>Studium 3</CustomAccordionButton>
                    <Accordion.Body>
                        <Form.Group className="mb-3" controlId="formStudy3">
                            <Form.Label>Studium</Form.Label>
                            <CustomFormControl
                                colors={colors}
                                placeholder="Abschluss"
                                type="text"
                                name="study3"
                                value={values.study3}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isValid={touched.study3 && !errors.study3}
                                isInvalid={errors.study3}
                                maxLength={settings.textInputLimit}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.study3}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formAcademicDegree3">
                            <Form.Label>Abschluss</Form.Label>
                            <CustomFormSelect
                                colors={colors}
                                name="academicDegree3"
                                value={values.academicDegree3}
                                isValid={touched.academicDegree3 && !errors.academicDegree3}
                                isInvalid={errors.academicDegree3}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            >
                                <option value="">Bitte auswählen...</option>
                                {Options.AcademicDegree.map((item, index) => <option key={index}>{item}</option>)}
                            </CustomFormSelect>
                            <Form.Control.Feedback type="invalid">
                                {errors.academicDegree3}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formStudy3Grade">
                            <Form.Label>Note</Form.Label>
                            <CustomFormControl
                                colors={colors}
                                placeholder="Note"
                                type="number"
                                name="studyGrade3"
                                value={values.studyGrade3 || ''}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isValid={touched.studyGrade3 && !errors.studyGrade3}
                                isInvalid={errors.studyGrade3}
                                maxLength={settings.textInputLimit}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.studyGrade3}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="finalYearOfStudy3">
                            <Form.Label>Abschlussdatum</Form.Label>
                            <CustomFormControl
                                colors={colors}
                                placeholder="Abschlussdatum"
                                type="date"
                                name="finalYearOfStudy3"
                                value={values.finalYearOfStudy3 || ''}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isValid={touched.finalYearOfStudy3 && !errors.finalYearOfStudy3}
                                isInvalid={errors.finalYearOfStudy3}
                                maxLength={settings.textInputLimit}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.finalYearOfStudy3}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </>
    );
};